import { Action } from '@ngrx/store';

export const UPDATE_NOTIFICATION = "Nueva notificación";


export class NotificationUpdate implements Action {
        readonly type = UPDATE_NOTIFICATION;
        constructor(public payload: Number){
        }
}


export type All = NotificationUpdate;